import { useContext } from "react";
import { CartContext } from "../../providers/CartContext";
import { StyledText, StyledTitle } from "../../style/typography";
import { CartCard } from "./CartCard";
import { ModalWrapper } from "./style";
import { MdClose } from "react-icons/md";
import { CartTotal } from "./CartTotal";

export const Modal = () => {
  const { cart, setModal } = useContext(CartContext);

  const modalRemove = () => {
    setModal(false);
  };

  return (
    <ModalWrapper>
      <div>
        {cart.length === 0 ? (
          <>
            <div>
              <StyledTitle tag="heading3" titleStyle="heading3" color="white">
                Carrinho de compras
              </StyledTitle>
              <button onClick={modalRemove}>
                <MdClose size={22} color="#ffff" />
              </button>
            </div>
            <ul>
              <StyledTitle tag="heading3" titleStyle="heading3">
                Sua sacola está vazia
              </StyledTitle>
              <StyledText
                tag="body"
                textStyle="body"
                weigth={400}
                color="#828282"
              >
                Adicione itens
              </StyledText>
            </ul>
          </>
        ) : (
          <>
            <div>
              <StyledTitle tag="heading3" titleStyle="heading3" color="white">
                Carrinho de compras
              </StyledTitle>
              <button onClick={modalRemove}>
                <MdClose size={22} color="#ffff" />
              </button>
            </div>
            <ul>
              {cart.map((itemCart) => {
                return <CartCard key={itemCart.id} itemCart={itemCart} />;
              })}
            </ul>
            <span></span>
            <CartTotal />
          </>
        )}
      </div>
    </ModalWrapper>
  );
};

// {currentSale.length === 0 ? (
//   <div className="cartItems">
//     <StyledTitle tag="heading3" titleStyle="heading3">
//       Sua sacola está vazia
//     </StyledTitle>
//     <StyledText tag="body-600" textStyle="body-600" weigth={400}>
//       Adicione itens
//     </StyledText>
//   </div>
// ) : (
//   <>
//     <Cart currentSale={currentSale} setCurrentSale={setCurrentSale} />
//     <CartTotal
//       cartTotal={cartTotal}
//       setCartTotal={setCartTotal}
//       currentSale={currentSale}
//       setCurrentSale={setCurrentSale}
//     />
//   </>
// )}
